import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  constructor(private _router: Router, public _route: ActivatedRoute) { }
  public loading: boolean = false;
  ngOnInit() {
    this.loading = true;
    this._initMobileRouter();
  }

  /**
 * Redirect to initial page in mobile app switch
 * check queryParam appRedirectUrl which is set from other app
 */
  private _initMobileRouter() {
    const isCordovaApp = document.URL.indexOf('http://') === -1
    if (isCordovaApp) {
      this._route.queryParams.subscribe(params => {
        if (params.appRedirectUrl) {
          this._router.navigateByUrl(params.appRedirectUrl);
        }
      });
    } else {
      this.loading = false;
    }
  };

}
